/* Not loaded on the storefront: the theme loads esp-case-pricing.min.js, a copy of this file. Shopify re-minifies .js assets into syntax iOS 13.0-13.3 cannot run, and serves .min.js files as they are. Make changes in esp-case-pricing.min.js. */
import { ruleFromMetafields, caseDiscountMessage, tierForQuantity, currencyDigits, discountedUnit } from "./esp-case-pricing-core.min.js";
class EspQuantityPricing extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const {
      signal
    } = this.controller;
    try {
      this.data = JSON.parse(this.querySelector("[data-volume-data]").textContent);
    } catch {
      return;
    }
    this.hasPricingInteraction = false;
    this.lastAnnouncedKey = null;
    this.pendingPriceAnnouncement = null;
    this.scope = this.closest("product-form") || this.closest(".shopify-section") || document;
    this.onChange = event => {
      var _event$target, _event$target$matches;
      if (!event || event.type === 'popstate' || (_event$target = event.target) !== null && _event$target !== void 0 && (_event$target$matches = _event$target.matches) !== null && _event$target$matches !== void 0 && _event$target$matches.call(_event$target, 'input[name="quantity"],input[name="selling_plan"],[data-esp-purchase],[data-esp-plan],.swt-input,input[name^="options"]')) this.hasPricingInteraction = true;
      this.render();
      requestAnimationFrame(() => {
        if (this.isConnected) this.render();
      });
    };
    this.onVariantChange = event => {
      var _event$detail;
      const id = (_event$detail = event.detail) === null || _event$detail === void 0 || (_event$detail = _event$detail.variant) === null || _event$detail === void 0 ? void 0 : _event$detail.id;
      if (id != null && !this.data.variants.some(variant => String(variant.id) === String(id))) return;
      this.onChange();
    };
    this.scope.addEventListener("change", this.onChange, {
      signal
    });
    this.scope.addEventListener("input", this.onChange, {
      signal
    });
    document.addEventListener("variant:change", this.onVariantChange, {
      signal
    });
    document.addEventListener("variant-change", this.onVariantChange, {
      signal
    });
    window.addEventListener("variant:change", this.onVariantChange, {
      signal
    });
    window.addEventListener("popstate", this.onChange, {
      signal
    });
    // Themes often replace the product form when a variant changes.
    this.observer = new MutationObserver(records => {
      if (records.some(r => !this.contains(r.target))) this.render();
    });
    this.observerOptions = {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["value", "checked"]
    };
    this.observer.observe(this.scope, this.observerOptions);
    this.priceWrites = new Map();
    this.ruleId = `esp-case-rule-${this.data.productId}-${EspQuantityPricing.nextId = (EspQuantityPricing.nextId || 0) + 1}`;
    this.querySelector('[data-volume-content]').id = this.ruleId;
    this.render();
  }
  disconnectedCallback() {
    var _this$controller, _this$observer;
    (_this$controller = this.controller) === null || _this$controller === void 0 || _this$controller.abort();
    (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
    clearTimeout(this.announcementTimer);
    this.pendingPriceAnnouncement = null;
    this.controller = null;
  }
  productForm() {
    var _forms$find;
    const forms = [...this.scope.querySelectorAll('form[action*="/cart/add"]')];
    return (_forms$find = forms.find(f => this.data.variants.some(v => {
      var _f$elements$namedItem;
      return String(v.id) === ((_f$elements$namedItem = f.elements.namedItem("id")) === null || _f$elements$namedItem === void 0 ? void 0 : _f$elements$namedItem.value);
    }))) !== null && _forms$find !== void 0 ? _forms$find : null;
  }
  currentVariant(form) {
    var _this$scope$matches, _this$scope, _ref, _form$elements$namedI, _form$elements$namedI2;
    // ESP retains the last available form ID when a sold-out option is selected.
    // Its product-form element holds the actual selection and emits on window.
    if ((_this$scope$matches = (_this$scope = this.scope).matches) !== null && _this$scope$matches !== void 0 && _this$scope$matches.call(_this$scope, "product-form") && "currentVariant" in this.scope) {
      const selected = this.scope.currentVariant;
      if (!selected) return undefined;
      const variant = this.data.variants.find(v => String(v.id) === String(selected.id));
      return variant ? {
        ...variant,
        available: variant.available && selected.available !== false
      } : undefined;
    }
    const id = (_ref = (_form$elements$namedI = form === null || form === void 0 || (_form$elements$namedI2 = form.elements.namedItem("id")) === null || _form$elements$namedI2 === void 0 ? void 0 : _form$elements$namedI2.value) !== null && _form$elements$namedI !== void 0 ? _form$elements$namedI : new URL(location.href).searchParams.get("variant")) !== null && _ref !== void 0 ? _ref : String(this.data.initialVariantId);
    return this.data.variants.find(v => String(v.id) === id);
  }
  quantityInput(form) {
    var _form$elements, _controls$find;
    const controls = [...((_form$elements = form === null || form === void 0 ? void 0 : form.elements) !== null && _form$elements !== void 0 ? _form$elements : [])].filter(e => e.matches('input[name="quantity"]'));
    return (_controls$find = controls.find(e => e.getClientRects().length > 0)) !== null && _controls$find !== void 0 ? _controls$find : controls.find(e => e.type !== "hidden" && !e.closest("[hidden]"));
  }
  selectedPlan(form) {
    return form === null || form === void 0 ? void 0 : form.elements.namedItem("selling_plan");
  }
  writePrice(element, price, prefix = "") {
    var _moneySpans$at, _prior$original;
    if (!element) return;
    const moneySpans = [...element.querySelectorAll(".transcy-money")];
    const target = (_moneySpans$at = moneySpans.at(-1)) !== null && _moneySpans$at !== void 0 ? _moneySpans$at : element;
    const text = target === element ? prefix + price : price;
    if (target.textContent === text) return;
    const prior = this.priceWrites.get(target);
    this.priceWrites.set(target, {
      original: (_prior$original = prior === null || prior === void 0 ? void 0 : prior.original) !== null && _prior$original !== void 0 ? _prior$original : target.textContent,
      written: text
    });
    target.textContent = text;
  }
  restorePrices() {
    for (const [target, value] of this.priceWrites) {
      if (target.isConnected && target.textContent === value.written) target.textContent = value.original;
    }
    this.priceWrites.clear();
  }
  renderPrices(variant, rule, form, plan) {
    var _this$quantityInput, _tier$percentBps;
    if (!variant || !Number.isSafeInteger(variant.price)) {
      this.restorePrices();
      return;
    }
    const main = this.scope.querySelector(".product-price .price");
    const controlsMainPrice = Boolean(rule) || [...this.priceWrites.keys()].some(target => main === null || main === void 0 ? void 0 : main.contains(target));
    const quantity = Number((_this$quantityInput = this.quantityInput(form)) === null || _this$quantityInput === void 0 ? void 0 : _this$quantityInput.value);
    const tier = variant.available && rule ? tierForQuantity(rule, quantity) : null;
    const digits = currencyDigits(this.data.currency);
    const minor = Math.round(variant.price / 100 * 10 ** digits);
    const price = new Intl.NumberFormat(document.documentElement.lang || "en-US", {
      style: "currency",
      currency: this.data.currency
    }).format(discountedUnit(minor, (_tier$percentBps = tier === null || tier === void 0 ? void 0 : tier.percentBps) !== null && _tier$percentBps !== void 0 ? _tier$percentBps : 0) / 10 ** digits);
    this.writePrice(this.scope.querySelector('[data-esp-regular-price]'), price);
    if (!controlsMainPrice) return;
    if (plan !== null && plan !== void 0 && plan.value) {
      var _this$scope$querySele2;
      const subscriptionPrice = (_this$scope$querySele2 = this.scope.querySelector('[data-esp-sub-price]')) === null || _this$scope$querySele2 === void 0 || (_this$scope$querySele2 = _this$scope$querySele2.textContent) === null || _this$scope$querySele2 === void 0 ? void 0 : _this$scope$querySele2.trim();
      if (subscriptionPrice) this.writePrice(main, subscriptionPrice);else {
        // Without the Subscribe box's price, return control to it.
        for (const [target, value] of this.priceWrites) {
          if (main !== null && main !== void 0 && main.contains(target) && target.textContent === value.written) {
            target.textContent = value.original;
            this.priceWrites.delete(target);
          }
        }
      }
    } else this.writePrice(main, price);
  }
  queuePriceAnnouncement(state) {
    var _this$pendingPriceAnn;
    if (!this.hasPricingInteraction) {
      var _state$key;
      this.lastAnnouncedKey = (_state$key = state === null || state === void 0 ? void 0 : state.key) !== null && _state$key !== void 0 ? _state$key : null;
      return;
    }
    if (!state || state.key === this.lastAnnouncedKey) {
      clearTimeout(this.announcementTimer);
      this.pendingPriceAnnouncement = null;
      return;
    }
    if (state.key === ((_this$pendingPriceAnn = this.pendingPriceAnnouncement) === null || _this$pendingPriceAnn === void 0 ? void 0 : _this$pendingPriceAnn.key)) return;
    clearTimeout(this.announcementTimer);
    this.pendingPriceAnnouncement = state;
    this.announcementTimer = setTimeout(() => {
      var _this$pendingPriceAnn2;
      if (!this.isConnected || ((_this$pendingPriceAnn2 = this.pendingPriceAnnouncement) === null || _this$pendingPriceAnn2 === void 0 ? void 0 : _this$pendingPriceAnn2.key) !== state.key) return;
      const status = this.querySelector('[data-volume-status]');
      if (status && status.textContent !== state.message) status.textContent = state.message;
      this.lastAnnouncedKey = state.key;
      this.pendingPriceAnnouncement = null;
    }, 150);
  }
  render() {
    var _variant$minimum, _variant$percent;
    const form = this.productForm();
    const variant = this.currentVariant(form);
    const plan = this.selectedPlan(form);
    const subscription = Boolean(plan === null || plan === void 0 ? void 0 : plan.value);
    const rule = ruleFromMetafields(String((_variant$minimum = variant === null || variant === void 0 ? void 0 : variant.minimum) !== null && _variant$minimum !== void 0 ? _variant$minimum : ""), String((_variant$percent = variant === null || variant === void 0 ? void 0 : variant.percent) !== null && _variant$percent !== void 0 ? _variant$percent : ""));
    const content = this.querySelector("[data-volume-content]");
    const visible = Boolean(form && (variant === null || variant === void 0 ? void 0 : variant.available) && rule && !subscription);
    content.hidden = !visible;
    const note = this.querySelector("[data-volume-editor-note]");
    if (note) note.hidden = visible;
    if (visible) this.querySelector("[data-volume-message]").textContent = caseDiscountMessage(rule);
    const quantityInput = this.quantityInput(form);
    if (quantityInput) {
      const descriptions = new Set((quantityInput.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      if (visible) descriptions.add(this.ruleId);else descriptions.delete(this.ruleId);
      if (descriptions.size) quantityInput.setAttribute('aria-describedby', [...descriptions].join(' '));else quantityInput.removeAttribute('aria-describedby');
    }
    // Only displayed text changes. Catalog values and subscription inputs remain
    // the original values, so a plan's own discount is not stacked on the case percentage.
    this.observer.disconnect();
    try {
      var _this$scope$querySele3;
      this.renderPrices(variant, rule, form, plan);
      const price = (_this$scope$querySele3 = this.scope.querySelector('.product-price .price')) === null || _this$scope$querySele3 === void 0 ? void 0 : _this$scope$querySele3.textContent.trim();
      const tier = visible ? tierForQuantity(rule, Number(quantityInput === null || quantityInput === void 0 ? void 0 : quantityInput.value)) : null;
      if (price && variant !== null && variant !== void 0 && variant.available) {
        const key = [variant.id, (plan === null || plan === void 0 ? void 0 : plan.value) || '', price, (tier === null || tier === void 0 ? void 0 : tier.percentBps) || 0].join('|');
        const messages = window.espAccessibilityStrings || {};
        const message = subscription ? messages.subscriptionPrice || 'Subscription unit price: {price}.' : tier ? messages.casePrice || 'Unit price: {price}. Case discount applied.' : messages.unitPrice || 'Unit price: {price}.';
        this.queuePriceAnnouncement({
          key,
          message: message.replace('{price}', price)
        });
      } else this.queuePriceAnnouncement(null);
    } finally {
      this.observer.observe(this.scope, this.observerOptions);
    }
  }
}
if (!customElements.get("esp-quantity-pricing")) customElements.define("esp-quantity-pricing", EspQuantityPricing);
